import { useElementSize } from "@/features/useElementSize"
import { IndexData } from "@/features_signal/indexData"
import styled from "@emotion/styled"
import { useEffect, useId, useMemo } from "react"
import { useNavigate } from "react-router-dom"
import { CategoryGameSearch } from "../components/CategoryGameSearch"
import { CategoryGameSelect } from "../components/CategoryGameSelect"
import { GameCardItem } from "../components/GameCardItem"
import { GridGameList } from "../components/GridGameList"
import { useSubPage } from "../hooks/useSubPage"

const SubContainer = styled.section`
    padding-top: 12rem;
    flex: 1;
    display: flex;
    flex-direction: column;
`

const ListContainer = styled.div`
    flex: 1;
`

export const SubPageGameCategory = () => {
    const {
        categoryId,
        keyword,
        sort,
        brands,
        ary,
        isLoading,
        hasMore,
        providerList,
        onLoadMore,
        setAction,
        setKeyword,
    } = useSubPage()
    const { elementRef, size } = useElementSize<HTMLDivElement>()

    const navigate = useNavigate()

    /**
     * 该页面是导航进入的, 读取的后台配置, 如果后台关闭了, 需要退出该页面
     */

    useEffect(() => {
        const keys = Object.keys(IndexData.dataNav.value).map((it) => it.toLowerCase())
        if (keys.length && !keys.includes(categoryId.toLowerCase())) {
            navigate("/", { replace: true })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [categoryId, IndexData.dataNav.value, navigate])

    const listId = useId()

    const listKey = useMemo(() => {
        return `${categoryId}_${brands}_${keyword.length < 3 ? "" : keyword}_${sort}_${listId}`
    }, [listId, categoryId, brands, keyword, sort])

    return (
        <SubContainer>
            <CategoryGameSearch
                val={keyword || ""}
                setVal={(_val: string) => {
                    setKeyword(_val)
                }}
            />
            <CategoryGameSelect
                sort={sort || ""}
                setSort={(_sort: string) => {
                    setAction("sort", _sort)
                }}
                brands={brands ? brands.split(",") : []}
                setBrands={(_sort: string[]) => {
                    setAction("brands", _sort.join(","))
                }}
                gameProviderList={providerList}
            />
            <ListContainer ref={elementRef}>
                <GridGameList<GameApiTypes.Fetcher.Result.GameList>
                    // 添加key解决 categoryId brands keyword 等 变化时, 该列表没有重新渲染的问题
                    key={listKey}
                    height={size?.height || 0}
                    list={ary}
                    isLoading={isLoading}
                    itemContent={(index, game) => {
                        return (
                            <GameCardItem
                                {...game}
                                key={`sub_game_item__${index}`}
                            />
                        )
                    }}
                    onLoadMore={() => {
                        if (hasMore && !isLoading) {
                            onLoadMore()
                        }
                    }}
                />
            </ListContainer>
        </SubContainer>
    )
}
